import _ from 'lodash';

export const getLanguageObject = () => {
  const globalLanguage = global ? global.Language : null;
  const windowLanguage = window ? window.Language : null;
  return windowLanguage || globalLanguage || {};
};

export const toBoolean = value => {
  if (['FALSE', 'false', false, '0', 0, null, -1].indexOf(value) !== -1) return false;
  if (['TRUE', 'true', true, '1', 1].indexOf(value) !== -1) return true;
  return !!value;
};

export const mergeStyles = (baseStyle, extendedStyle) => {
  const style = baseStyle;
  _.mergeWith(baseStyle, extendedStyle, (objVal, srcVal) => `${objVal} ${srcVal}`);

  return style;
};

export const noop = () => {};
